import { ArrowUpRight, MapPin } from "lucide-react";
import { waLink } from "../../lib/wa";

export const Hero = () => {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative pt-28 pb-16 md:pt-40 md:pb-28 overflow-hidden"
        >
            {/* dotted background */}
            <div className="absolute inset-0 dotted-bg opacity-50 pointer-events-none" />

            <div className="max-w-7xl mx-auto px-5 md:px-10 relative">
                <div className="grid grid-cols-12 gap-4 md:gap-10 items-end">
                    {/* Left: Editorial heading */}
                    <div className="col-span-12 lg:col-span-8">
                        <div className="flex items-center gap-3 mb-8 text-jws-muted">
                            <span className="h-px w-10 bg-jws-text" />
                            <span className="text-xs uppercase tracking-[0.3em] font-medium">
                                Studio Web · Est. Jayapura
                            </span>
                        </div>

                        <h1
                            data-testid="hero-headline"
                            className="font-display font-bold tracking-[-0.04em] leading-[0.95] text-[2.75rem] sm:text-6xl md:text-[6.5rem] lg:text-[8rem]"
                        >
                            Website
                            <br />
                            yang bikin
                            <br />
                            <span className="italic font-light text-jws-primary">
                                UMKM&nbsp;
                            </span>
                            <span className="relative">
                                naik kelas
                                <svg
                                    className="absolute -bottom-3 left-0 w-full"
                                    viewBox="0 0 400 14"
                                    fill="none"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M2 11C80 4 200 2 398 8"
                                        stroke="#E38833"
                                        strokeWidth="3"
                                        strokeLinecap="round"
                                    />
                                </svg>
                            </span>
                            .
                        </h1>
                    </div>

                    {/* Right: Sub copy + meta */}
                    <div className="col-span-12 lg:col-span-4 lg:pb-6">
                        <p
                            data-testid="hero-sub"
                            className="text-lg md:text-xl text-jws-muted leading-relaxed font-light max-w-md"
                        >
                            Kami bantu pelaku usaha di Papua punya{" "}
                            <span className="text-jws-text font-medium">
                                kehadiran digital yang dipercaya
                            </span>
                            &nbsp;— website bersih, cepat, dan benar-benar dipakai
                            pelanggan. Bukan sekadar online.
                        </p>

                        <div className="mt-8 flex items-center gap-2 text-sm text-jws-muted">
                            <MapPin className="h-4 w-4" />
                            Abepura, Jayapura — Papua
                        </div>
                    </div>
                </div>

                {/* CTA strip */}
                <div className="mt-12 md:mt-20 flex flex-col md:flex-row items-stretch md:items-center gap-5 md:gap-10">
                    <a
                        href={waLink()}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="hero-wa-cta"
                        className="btn-arrow group inline-flex items-center justify-between md:justify-start gap-3 md:gap-4 rounded-full bg-jws-primary text-white pl-5 md:pl-7 pr-2 md:pr-3 py-2.5 md:py-3 hover:bg-jws-primaryHover transition-all hover:-translate-y-0.5 shadow-[0_8px_24px_-12px_rgba(168,60,34,0.5)] w-full md:w-auto"
                    >
                        <span className="font-display text-base md:text-xl tracking-tight">
                            Diskusikan proyek anda
                        </span>
                        <span className="h-10 w-10 md:h-12 md:w-12 grid place-items-center rounded-full bg-jws-bg text-jws-primary shrink-0">
                            <ArrowUpRight className="h-4 w-4 md:h-5 md:w-5" />
                        </span>
                    </a>

                    <div className="flex items-center gap-4 md:gap-6 text-xs md:text-sm text-jws-muted">
                        <div className="flex items-center gap-2">
                            <span className="h-2 w-2 rounded-full bg-emerald-600" />
                            Slot terbatas
                        </div>
                        <div className="hidden sm:block h-4 w-px bg-jws-border" />
                        <div className="hidden sm:block">
                            Konsultasi awal{" "}
                            <span className="text-jws-text font-medium">
                                gratis
                            </span>
                        </div>
                    </div>
                </div>

                {/* Stats row */}
                <div className="mt-16 md:mt-28 grid grid-cols-2 md:grid-cols-4 gap-px bg-jws-border border border-jws-border rounded-2xl overflow-hidden">
                    {[
                        { v: "30+", k: "Proyek selesai" },
                        { v: "4 hari", k: "Kecepatan launch rata-rata" },
                        { v: "100%", k: "Mobile-first responsive" },
                        { v: "24/7", k: "Support via WhatsApp" },
                    ].map((s) => (
                        <div
                            key={s.k}
                            className="bg-jws-bg p-5 md:p-8"
                            data-testid={`hero-stat-${s.k.split(" ")[0].toLowerCase()}`}
                        >
                            <div className="font-display text-2xl md:text-4xl tracking-tight">
                                {s.v}
                            </div>
                            <div className="mt-2 text-xs md:text-sm text-jws-muted">
                                {s.k}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
